import { render, staticRenderFns } from "./ChangeRoleModal.vue?vue&type=template&id=e530be84&"
import script from "./ChangeRoleModal.vue?vue&type=script&lang=ts&"
export * from "./ChangeRoleModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports